import React from "react";
import googleG from "./google-g.png";

interface Props {
  size?: number;
}

// The asset is exported straight from the design (Figma `image 1865` in the
// "Sign in with Google" button) — Google's 2025 gradient "G", which has no flat
// colour segments to reproduce as paths. Do not redraw or recolour it; if the
// design changes, re-export.
//
// Intrinsic 128×131, so the height is derived to keep the ratio instead of
// forcing a square and squashing it.
const ASPECT_RATIO = 131 / 128;

const GoogleIcon = ({size = 20}: Props) => (
  <img
    src={googleG}
    width={size}
    height={Math.round(size * ASPECT_RATIO)}
    alt=""
    aria-hidden="true"
    style={{display: "block"}}
  />
);

GoogleIcon.defaultProps = {
  size: 20,
};

export default GoogleIcon;
